import { useEffect, useState } from 'react';
import { socket } from '../chat/useSocket';
import { supportRequest, supportToken } from './supportApi';

export default function useSupportUnread(notify = false) {
  const [unread, setUnread] = useState(0);
  useEffect(() => {
    let active = true;
    let token = '';
    let previous = null;
    const register = () => {
      token = supportToken();
      previous = null;
      if (token) socket.emit('supportRegister', { token });
      else socket.emit('supportUnregister');
    };
    const refresh = async () => {
      if (token !== supportToken()) register();
      if (!supportToken()) { if (active) setUnread(0); return; }
      try {
        const data = await supportRequest('unread');
        if (active) {
          const count = Number(data.unread) || 0;
          if (notify && previous !== null && count > previous) window.dispatchEvent(new Event('supportNotification'));
          previous = count;
          setUnread(count);
        }
      }
      catch { /* Keep the last confirmed count during a network outage. */ }
    };
    register(); refresh();
    socket.on('connect', register);
    socket.on('supportChanged', refresh);
    const timer = setInterval(refresh, 10000);
    return () => { active = false; clearInterval(timer); socket.off('connect', register); socket.off('supportChanged', refresh); };
  }, [notify]);
  return unread;
}
